import { useMemo } from 'react'
import {
    materialRequirementsPopulate,
    shipmentAvailabilityPopulate,
    shipmentPeoplePopulate,
} from '../../../../../constants/shipment-populate'
import { Zones } from '../../../../../../../../types/api/print-queue-entry'
import { DocumentId, EndpointQueryParameters } from '../../../../../../../../types/strapi/strapi'

export default function useQueryParams(machineDocId: DocumentId) {
    return useMemo(() => {
        const params: EndpointQueryParameters = {
            filters: {
                zone: { $eq: Zones.Main },
                machine: { documentId: { $eq: machineDocId } },
            },
            populate: {
                print_job: {
                    populate: {
                        shipment: {
                            populate: {
                                ...shipmentAvailabilityPopulate,
                                ...shipmentPeoplePopulate,
                                client: true,
                                shipment_positions: true,
                                materialRequirements: { populate: materialRequirementsPopulate },
                                machine: true,
                                additional_machines: true,
                                calculated: true,
                                calculatedOnActual: true,
                            },
                        },
                        print_queue_entries: {
                            populate: {
                                machine: true,
                            },
                        },
                        print_job_executors: {
                            populate: {
                                machine: true,
                            },
                        },
                    },
                },
                machine: {
                    populate: {
                        machine_type: true,
                    },
                },
            },
            sort: ['sort:asc'],
        }
        return params
    }, [machineDocId])
}
